import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { Icon, DLMenu } from 'appSrc/components/UI';
import { showModal } from 'appSrc/redux/actions';
import style from './styles/style.module.css';

class CategoriesTableRow extends Component {
    constructor( props ) {
        super( props );

        this.state = {
            category: this.props.category,
        };
    }
    UNSAFE_componentWillReceiveProps( nextProps ) {
        if( nextProps.category != this.props.category ) {
            this.setState( {
                category: nextProps.category,
            } );
        }
    }
    updateCategory = ( id, data ) => {
        this.props.updateCategory( id, data )
        .then( ( category ) => {
            var updatedCategory = {
                ...this.state.category,
                ...category,
            };
            this.setState( { category: updatedCategory } );
        } );
    }
    openEditModal = ( category ) => {
        this.props.showEditModal( category, this.onEditSubmit );
    }
    onEditSubmit = ( update ) => {
        return this.props.updateCategory( this.state.category.id, update )
        .then( ( category ) => {
            var updatedCategory = {
                ...this.state.category,
                ...category,
            };
            this.setState( { category: updatedCategory } );
        } );
    }



    render() {
        const { category } = this.state;
        const { parents, visible, isOpen } = this.props;

        var collapseMark = (
            <Icon source='fontAwesome' className='dropdown' icon='fas/faMinus'
            style={ { color: '#e0e0e0' } } />
        );

        if( category.child_categories.length > 0 ) {
            if( isOpen ) {
                collapseMark = (
                    <Icon source='fontAwesome' className='dropdown' icon='fas/faChevronDown'
                    style={ { color: '#6461ec' } }
                    onClick={ this.props.onToggle } />
                );
            } else {
                collapseMark = (
                    <Icon source='fontAwesome' className='dropdown' icon='fas/faChevronUp'
                    style={ { color: '#6461ec' } }
                    onClick={ this.props.onToggle } />
                );
            }
        }
        return (
            <li className={ style.tableRow + ' dl-table-body' } data-visible={ visible }>
                <div className={ style.tableCell }>
                    <div className={ style.complexContent }>
                        <span className={ style.nestMark } style={ { minWidth: parents.length + 'em' } } />
                        <div className={ style.collapseMark }>
                            { collapseMark }
                        </div>
                        <div>
                            { category.name }
                        </div>
                    </div>
                </div>
                <div className={ style.tableCell + ' ' + style.actionsCell } >
                    { parseInt( category.curated_articles_count ) }
                </div>
                <div className={ style.tableCell + ' ' + style.actionsCell } >
                    { parseInt( category.desires_count ) }
                </div>
                <div className={ style.tableCell } >
                    { category.status }
                </div>
                <div className={ style.tableCell + ' ' + style.actionsCell } >
                    <DLMenu
                    icon={ ( <Icon source='fontAwesome' className='dropdown' icon='fas/faEllipsisH' style={ { color: '#6461ec' } } faSize='2x' /> ) }
                    direction='left' >
                        <DLMenu.Item text='Edit'
                        onClick={ () => {
                            this.openEditModal( category );
                        } }/>
                        <DLMenu.Item text={ !( category.status == 'published' ) ? 'Publish' : 'Unpublish' }
                        onClick={ () => {
                            this.updateCategory( category.id, {
                                status: !( category.status == 'published' ) ? 'published' : 'draft',
                                title: category.name,
                            } );
                        } }/>
                    </DLMenu>
                </div>
            </li>
        );
    }
}

const mapDispatchToProps = ( dispatch ) => {
    return {
        updateCategory: ( id, data ) => {
            return dAPI.patch( `/admin/categories/${ id }`, data )
            .then( response => response[1][0] )
            .catch( () => {} );
        },
        showEditModal: ( category, callback ) => {
            dispatch( showModal( 'editCategoryModal', {
                category: category,
                callback: callback,
            } ) );
        },
    };
};

export default connect( null, mapDispatchToProps )( CategoriesTableRow );
